import { render } from "./Footer.vue?vue&type=template&id=a7a3cdd8&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=a7a3cdd8&scoped=true&lang=scss"
import "./Footer.vue?vue&type=style&index=1&id=a7a3cdd8&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7a3cdd8"]])

export default __exports__